"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SUCCESS = 'success';
var ERROR = 'error';
var EXCLAMATION = 'exclamation';
var INFO = 'info';
var EMPTY = 'empty';
var CONQUERED = 'conquered';
var NO_RESULTS = 'no-results';
var KEY = 'key';
var METRICS = 'metrics';
var REPORTING = 'reporting';
var ROUTING = 'routing';
var SETTINGS = 'settings';

var Illustration = function Illustration(_ref) {
  var name = _ref.name,
      _ref$animated = _ref.animated,
      animated = _ref$animated === void 0 ? true : _ref$animated,
      props = _objectWithoutProperties(_ref, ["name", "animated"]);

  var styles = (0, _classnames.default)('co-illus', name, {
    'co-illus--animated': animated
  });
  return _react.default.createElement("div", _extends({
    className: styles
  }, (0, _getNativeProps.default)(props)), animated ? _react.default.createElement(ShadowedFigure, null) : _react.default.createElement(Figure, null));
};

Illustration.CONQUERED = CONQUERED;
Illustration.EMPTY = EMPTY;
Illustration.ERROR = ERROR;
Illustration.EXCLAMATION = EXCLAMATION;
Illustration.INFO = INFO;
Illustration.KEY = KEY;
Illustration.METRICS = METRICS;
Illustration.NO_RESULTS = NO_RESULTS;
Illustration.REPORTING = REPORTING;
Illustration.ROUTING = ROUTING;
Illustration.SETTINGS = SETTINGS;
Illustration.SUCCESS = SUCCESS;
Illustration.propTypes = {
  name: (0, _propTypes.oneOf)([CONQUERED, EMPTY, ERROR, EXCLAMATION, INFO, KEY, METRICS, NO_RESULTS, REPORTING, ROUTING, SETTINGS, SUCCESS]).isRequired,
  animated: _propTypes.bool
};

var Figure = function Figure() {
  return _react.default.createElement("div", {
    className: "co-illus__figure"
  });
};

var ShadowedFigure = function ShadowedFigure() {
  return _react.default.createElement("div", {
    className: "co-illus__shadow"
  }, _react.default.createElement(Figure, null));
};

var _default = Illustration;
exports.default = _default;
Illustration.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Illustration",
  "props": {
    "animated": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'conquered'",
          "computed": false
        }, {
          "value": "'empty'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }, {
          "value": "'exclamation'",
          "computed": false
        }, {
          "value": "'info'",
          "computed": false
        }, {
          "value": "'key'",
          "computed": false
        }, {
          "value": "'metrics'",
          "computed": false
        }, {
          "value": "'no-results'",
          "computed": false
        }, {
          "value": "'reporting'",
          "computed": false
        }, {
          "value": "'routing'",
          "computed": false
        }, {
          "value": "'settings'",
          "computed": false
        }, {
          "value": "'success'",
          "computed": false
        }]
      },
      "required": true,
      "description": ""
    }
  }
};